import http from '@/http.js';
import eventBus from '@/eventBus.js';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useModifJeu(props, {emit}) {
    const identifiantJeu = ref(props.idjeu);
    const idUtilisateur = ref('');
    const schemas = ref([]);
    const schema = ref({});
    const nom = ref('');
    const description = ref('');
    const requetes = ref([]);

    const toastMessage = ref('');
    const showNotification = ref(false);
    const toastType = ref('info');
    const duration = ref(5000);

    const invalid = yup.object({
        nom: yup.string().required('Ce champ est obligatoire'),
        description: yup.string().required('Ce champ est obligatoire'),
    });

    const { handleSubmit } = useForm({
        validationSchema: invalid,
    });

    onMounted(() => {
        http.getSchema().then((data) => {
            schemas.value = data;
        });

        if (props.idjeu !== undefined) {
            http.loadJeuRequete(props.idjeu).then((data) => {
                nom.value = data.nom;
                description.value = data.description;
                schema.value = data.schema;
                requetes.value = data.requetes;
            });
        }
    });

    onBeforeUnmount(() => {
        eventBus.off('modifierJeuRequete', emitModifierJeu);
    });

    const emitModifierJeu = handleSubmit(async (values) => {
        try {
            const jeuRequeteData = {
                idJeuRequetes: identifiantJeu.value,
                idUtilisateur: idUtilisateur.value,
                nom: values.nom,
                description: values.description,
                schema: schema.value,
                requetes: requetes.value,
            };
            const data = await http.updateJeuRequete(jeuRequeteData);
            identifiantJeu.value = data;
            emit('close');
            eventBus.emit('reloadJeu');
            emit('notification', {
                showNotification: true,
                toastMessage: 'Jeu de requêtes modifié avec succès!',
                toastType: 'success',
            });
        } catch (error) {
            emit('notification', {
                showNotification: true,
                toastMessage: 'Erreur lors de la modification du jeu de requête.',
                toastType: 'danger',
            });
        }
    });

    return {
        idUtilisateur,
        nom,
        description,
        schema,
        schemas,
        requetes,
        emitModifierJeu,
        toastMessage,
        showNotification,
        toastType,
        duration,
    };
}